import React, { useEffect, useState } from 'react';

const logoStyle: React.CSSProperties = {
  height: '63.34px',
  margin: '20px'
}

const SmallerLogoIconComponent: React.FC = () => {
  const [imageSrc, setImageSrc] = useState('');
  const customerConfigKey = (process.env.REACT_APP_CUSTOMER_CONFIG || 'default').trim();

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const module = await import(`../../../styles/icon/${customerConfigKey}/logo.png`);
        setImageSrc(module.default);
      }
      catch(err) {
        console.error('Error while loading customer logo', err);
      }
    }

    fetchLogo();
  }, [customerConfigKey]);

  return <img src={imageSrc} alt="Not found" style={logoStyle}/>;
}

export default SmallerLogoIconComponent;